import { useState, forwardRef, useImperativeHandle } from "react";
import ButtonReal from './small/ButtonReal'
import AddButton from './small/AddButton'


 const Modal = forwardRef(({showAddBtn, btnText, title, saveText, submitFunction, children, displaySubmit, noBtn, btnDisabled}, ref) => {
  const [showModal, setShowModal] = useState(false)
  const updateShow = () => {
    setShowModal(true)
  }
  useImperativeHandle(ref, () => ({
    updateShow: updateShow
  }))

  return (
    <>
      {!noBtn
      ? showAddBtn
        ? <AddButton onClick={() => {setShowModal(true)}} />
        : <ButtonReal text={btnText} onClick={() => {setShowModal(true)}} />
      : null
      }
      {showModal ? (
        <>
          <div
            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
          >
            <div className="relative max-h-screen min-w-[20rem] w-auto my-6 mx-auto max-w-3xl">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-3xl font-semibold">
                    {title}
                  </h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>
                {/*body*/}
                <div className="relative p-6 flex-auto">
                  {children}
                </div>
                {/*footer*/}
                <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                  <button
                    className="text-danger-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    Uždaryti
                  </button>
                  {displaySubmit
                  ? <ButtonReal disabled={btnDisabled} text={saveText} onClick={() => {
                    submitFunction()
                    setShowModal(false)
                  }} />
                  : null}
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
})

Modal.defaultProps = {
  showAddBtn: false,
  displaySubmit: true,
  saveText: '',
  submitFunction: () => {},
  noBtn: false,
  btnDisabled: false
}

export default Modal